import React from 'react';
import { AppLoader } from '@/components/common/atoms/AppLoader';

interface LoadingSpinnerProps {
  message?: string;
}

/**
 * Full-page loading state, used while the app itself is not yet usable
 * (auth callback, organisation config lookup).
 *
 * The spinner is `AppLoader` so the branded mark stays in one place; this component
 * only adds the full-screen chrome and the longer supporting copy.
 */
const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ message }) => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-slate-50 to-slate-100 dark:from-slate-950 dark:to-slate-900">
      <div className="text-center">
        <AppLoader size="large" className="mb-8" label={message || 'Loading'} />

        <div className="space-y-2" aria-hidden="true">
          <p className="text-lg font-semibold text-slate-900 dark:text-white motion-safe:animate-fade-in">
            {message || 'Loading'}
          </p>
          <p className="text-sm text-slate-500 dark:text-slate-400 motion-safe:animate-fade-in-delay">
            Please wait a moment...
          </p>

          <div className="flex justify-center gap-1 mt-4">
            <div className="w-2 h-2 bg-indigo-500 rounded-full motion-safe:animate-bounce-dot-1" />
            <div className="w-2 h-2 bg-indigo-500 rounded-full motion-safe:animate-bounce-dot-2" />
            <div className="w-2 h-2 bg-indigo-500 rounded-full motion-safe:animate-bounce-dot-3" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoadingSpinner;
